import { initializeApollo } from '@/graphql/client';
import type {
  UserDetailsQuery,
  UserDetailsQueryVariables,
  UserFragment,
} from '@/graphql/saleor/api';
import { UserDetailsDocument } from '@/graphql/saleor/api';
import { userState } from '@/states/user';

export const userFetch = async (
  refresh = false,
): Promise<UserFragment | null> => {
  const client = initializeApollo();

  if (userState.user && !refresh) {
    return userState.user as UserFragment;
  }

  const { data } = await client.query<
    UserDetailsQuery,
    UserDetailsQueryVariables
  >({
    query: UserDetailsDocument,
    fetchPolicy: 'no-cache',
  });

  return data?.me ?? null;
};
